module.exports = __webpack_public_path__ + "static/media/华科联创@2x.4d04ca43.png";